export default __webpack_public_path__ + "static/media/shuffle-cards.a372d287.mp3";